import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { saveVendor, getVendors, getVendor } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializeVendorForm } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import { selectVendorModel } from 'selectors/entitySelector';
import util from 'library/util';
import { vendorEditCrumb, vendorAddCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import CountryRegions from 'screens/components/basic/CountryRegions';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';
// Advanced Components
import AddressInfo from 'screens/components/advanced/AddressInfo';

class VendorSave extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: ""
        };
    }

    componentWillMount() {
        const vendorId = this.props.params ? this.props.params.id : null;
        //if true dispatch an action to retrive doctor data from API and set Status to EDIT
        if (vendorId) {
            this.setState({ status: "EDIT" });
            this.props.getVendor(vendorId);
        }
        //if false dispatch an action to clean the form and set default values, Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
    }

    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != null && newProps.saveSuccess !== this.props.saveSuccess) || (newProps.saveError != null && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
    }

    //when Vendor is saved successfully
    saveSuccess = () => {
        this.props.callListView();
        this.props.showVendorSuccess(this.state.status === "EDIT" ? LOOKUP.vendor.messages.editedMessage : LOOKUP.vendor.messages.createdMessage);
        if (this.props.isDialog) {
            this.props.getVendors();
        }
    }

    //when Vendor is not saved, failure
    saveFailure = () => {
        this.props.showVendorError(LOOKUP.vendor.messages.saveErrorMessage);
    }

    saveVendor = () => {
        const p = this.props;
        let vendor = this.props.vendorModel;

        const validators = [
            [p.name + 'Name', vendor => (vendor.Name && vendor.Name !== null && vendor.Name !== ""), "Business Name"]
            // [p.name + 'LicenseNumber', vendor => (vendor.LicenseNumber && vendor.LicenseNumber !== null && vendor.LicenseNumber !== ""), 'License Number'],
            // [p.name + 'CategoryId', vendor => vendor.CategoryId > 0, "Category"],
            // [p.name + 'Contact', vendor => (vendor.Contact && vendor.Contact !== null && vendor.Contact !== ""), "Contact"],
            // [p.name + 'Phone', vendor => (vendor.Phone && vendor.Phone !== null && vendor.Phone !== ""), "Phone"],
            // [p.name + 'Email', vendor => (vendor.Email && vendor.Email !== null && vendor.Email !== ""), "Email"],
            // [p.name + 'Address', vendor => (vendor.Address && vendor.Address !== null && vendor.Address !== ""), "Address"],
            // [p.name + 'Country', vendor => (vendor.Country && vendor.Country !== null && vendor.Country !== ""), "Country"],
            // [p.name + 'ProvinceState', vendor => (vendor.State && vendor.State !== null && vendor.State !== ""), "Province"],
            // [p.name + 'City', vendor => (vendor.City && vendor.City !== null && vendor.City !== ""), "City"],
            // [p.name + 'PostalCode', vendor => (vendor.PostalCode && vendor.PostalCode !== null && vendor.PostalCode !== ""), "Postal Code"] //Needs to change the name of property
        ];

        if (util.validate(validators, vendor, this.props.formError)) {
            this.props.saveVendor(vendor);
        }
    };

    cancelVendor = () => {
        this.props.callListView();
    };

    /*Missing Fields
        - MMJMenu Integration Code -> MMJ Menu
        - License Type -> MMJ Menu /  Vendor Type -> MJ Freeway
        - Notes -> MJ Freeway
    */


    render() {
        const p = this.props;
        const isDialog = p.isDialog || false;
        const breadCrumbPage = this.state.status === 'EDIT' ? vendorEditCrumb : vendorAddCrumb

        const header = isDialog ? null : (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.inventory.items.vendor.link}>{LOOKUP.menu.inventory.items.vendor.text}</Link></li>
                    <li className="active">Manage Vendor</li>
                </ol>
                <h2 className="purpleText">Manage Vendor <Button type="HeaderBackPage" onTouchTap={() => this.props.callListView()} /></h2>
            </div>);

        return (
            <Grid headerContent={breadCrumbPage}>
                <CardSimple title="Profile" className="p-1 mt-2">
                    {(this.state.status === 'EDIT')
                        ?
                        <div className="row">
                            <div className="col-lg-8 col-xl-8">
                                <TextInput name={p.name + "Id"}
                                    label={LOOKUP.patient.id.label}
                                    floatingLabelText={LOOKUP.patient.id.label}
                                    hintText={LOOKUP.patient.id.hintText}
                                    disabled={true}
                                    fullWidth={true} />
                            </div>
                            <div className="col-xs-12 col-sm-2 col-md-2 col-lg-4 col-xl-4">
                                <ToggleInput className="vendor_status btnToggleLabel" name={`${p.name}Status`} label={"Status"} />
                            </div>
                        </div>
                        :
                        null
                    }
                    <div className="row">
                        <div className="col-lg-6">
                            <TextInput name={`${p.name}Name`}
                                floatingLabelText={LOOKUP.vendor.name.label} fullWidth={true} hintText={LOOKUP.vendor.name.hintText} />
                        </div>
                        <div className="col-lg-6">
                            <TextInput name={`${p.name}LicenseNumber`} floatingLabelText={LOOKUP.vendor.licenseNumber.label} fullWidth={true} hintText={LOOKUP.vendor.licenseNumber.hintText} />
                        </div>
                    </div>
                    <div className="row">
                        {this.props.isVape ? null : (
                            <div className="col-lg-6">
                                <SelectInput name={`${p.name}CategoryId`} floatingLabelText={LOOKUP.vendor.category.label} options={p.categories} hintText={LOOKUP.vendor.category.hintText} required />
                            </div>
                        )}
                        <div className="col-lg-6">
                            <TextInput name={`${p.name}Website`} floatingLabelText={LOOKUP.vendor.website.label} fullWidth={true} hintText={LOOKUP.vendor.website.hintText} />
                        </div>
                    </div>
                </CardSimple>
                <br />
                <CardSimple title="Contact" className="p-1">
                    <AddressInfo name={p.name} />
                    <div className="row">
                        <div className="col-lg-6">
                            <TextInput name={`${p.name}Contact`} floatingLabelText={LOOKUP.vendor.contact.label} fullWidth={true} hintText={LOOKUP.vendor.contact.hintText} />
                        </div>
                        <div className="col-lg-6">
                            <MaskedTextInput
                                fullWidth={true}
                                name={`${p.name}Phone`}
                                floatingLabelText={LOOKUP.vendor.phone.label}
                                hintText={LOOKUP.vendor.phone.label}
                                mask="(999) 999-9999" />
                        </div>
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}Email`} floatingLabelText={LOOKUP.vendor.email.label} fullWidth={true} hintText={LOOKUP.vendor.email.hintText} />
                        </div>
                    </div>

                </CardSimple>
                <br />
                <div className="row marginRightMobile">
                    <div className="col-lg-12">
                        <Button name="buttonSave"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.vendor.controls.saveButton}
                            primary={true}
                            onTouchTap={() => this.saveVendor()} />

                        <Button name="cancelButton"
                            className="pull-right btn-space btnCleanSearch"
                            label={LOOKUP.vendor.controls.cancelButton}
                            onTouchTap={() => this.cancelVendor()} />
                    </div>
                </div>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        vendorModel: selectVendorModel(state, props.name),
        categories: state.form[props.name + "Categories"],
        saveSuccess: state.form[props.name + "SaveSuccess"],
        isVape: state.common.applicationSettings.isVape
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        saveVendor: (model) => dispatch(saveVendor(model, props.name)),
        init: (name) => dispatch(initializeVendorForm(name)),
        showVendorSuccess: (message) => dispatch(showSnackbar(message)),
        getVendors: () => dispatch(getVendors(1, 1000)),
        getVendor: (vendorId) => dispatch(getVendor(vendorId, props.name)),
        showVendorError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error })
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(VendorSave);